import { render, staticRenderFns } from "./NoEdited.vue?vue&type=template&id=04ec3476&"
import script from "./NoEdited.vue?vue&type=script&lang=js&"
export * from "./NoEdited.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/Users/administrador/developments/dtouch/dtouch-client/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib'
import { VBtn } from 'vuetify/lib'
import { VCol } from 'vuetify/lib'
import { VDivider } from 'vuetify/lib'
import { VRow } from 'vuetify/lib'
installComponents(component, {VAlert,VBtn,VCol,VDivider,VRow})
